export default __webpack_public_path__ + "static/Data-Hover-cb00c69bfa68a0325dd030432e9bbcd0.svg";